import { useMediaQuery } from "@mui/system";
import { useEffect, useRef } from "react";
import SyntaxHighlighter from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { ParsedLog } from "../../../../../api/useAPI";

interface Props {
  contentStr: string;
  currentSummary: ParsedLog;
}

function lineNumerStyle(
  line: number,
  parsedLog: ParsedLog,
): React.CSSProperties {
  if (parsedLog.errorLines.includes(line)) {
    return {
      backgroundColor: "rgba(255, 27, 27, 1)",
    };
  }

  if (parsedLog.warningLines.includes(line)) {
    return {
      backgroundColor: "rgba(255, 214, 32, 1)",
    };
  }

  return {};
}

export default ({ contentStr: content, currentSummary }: Props) => {
  const codeTextRef = useRef<HTMLPreElement>(null);

  useEffect(() => {
    if (codeTextRef.current?.style) {
      codeTextRef.current.childNodes.forEach((node) => {
        (node as any).style.maxHeight = "85vh";
        (node as any).style.display = "block";
      });
      setTimeout(() => {
        codeTextRef.current?.scrollTo(0, codeTextRef.current?.scrollHeight);
      }, 100);
    }
  }, [content]);

  const isBig = useMediaQuery("(min-width:600px)");
  const fontSize = isBig ? "13px" : "8px";

  return (
    <SyntaxHighlighter
      language="text"
      lineNumberStyle={(num) => lineNumerStyle(num, currentSummary)}
      style={{ ...oneDark }}
      customStyle={{
        fontSize,
        margin: 6,
        overflow: "scroll",
      }}
      showLineNumbers
      wrapLines
      lineNumberContainerStyle={{
        paddingRight: "5px",
      }}
      showInlineLineNumbers={true}
      ref={codeTextRef as React.RefObject<any>}
    >
      {content}
    </SyntaxHighlighter>
  );
};
